import HolidayMasterPage from './HolidayMasterPage';

export default HolidayMasterPage;
